import { Route, Routes } from 'react-router-dom';

import AllTasks from './all/All';
import { Details } from './details/Details';

import { AppRoutes } from 'config/routes';
import { NewRequestPage } from './update-task';

function ShipmentTasks() {
  const { NewRequest, RequestApproval } = AppRoutes.Dashboard.ShipmentTasks;

  return (
    <Routes>
      <Route path="/" element={<AllTasks />} />
      <Route path="/:id/*" element={<Details />} />

      <Route path={NewRequest} element={<NewRequestPage />} />
      <Route path={RequestApproval + '/:id'} element={<NewRequestPage />} />

      <Route path={NewRequest + '/:id'} element={<NewRequestPage />} />
    </Routes>
  );
}

export default ShipmentTasks;
